 <!-- Back to top -->
 <a [routerLink]="" (click)="topFunction($event)" id="back-to-top" class="back-to-top fixed rounded-full z-10 bottom-5 end-5 h-9 w-9 text-center bg-cyan-600 hover:bg-cyan-800 text-white leading-9" [ngClass]="scroll ? 'block' : 'hidden'"><i class="mdi mdi-arrow-up"></i></a>
 <!-- Back to top -->
